import { fetchListCatalogs } from 'common/api/documentCatalog';
import { ALLIANCE_DOCUMENTS_CATEGORY, DOCUMENTS_TYPE } from 'common/constants';

import {
    FETCH_DOCUMENTS,
    FETCH_DOCUMENTS_FAILURE,
    FETCH_DOCUMENTS_SUCCESS,
} from '../../actionTypes';
import { installerProfileActions } from '../../reducer';

export default () => (dispatch) => {
    dispatch(installerProfileActions[FETCH_DOCUMENTS]());

    fetchListCatalogs()
        .then((response) => {
            const dataFiltered = response.data.data.filter(
                (item) =>
                    item.category === ALLIANCE_DOCUMENTS_CATEGORY &&
                    item.type === DOCUMENTS_TYPE,
            );
            dispatch(
                installerProfileActions[FETCH_DOCUMENTS_SUCCESS](dataFiltered),
            );
        })
        .catch((error) =>
            dispatch(
                installerProfileActions[FETCH_DOCUMENTS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
